import {useContext} from 'react';
import {AudioTrack, useTracks} from '@livekit/components-react';
import {Track} from 'livekit-client';
import {ParticipantViewsContext} from './callContext';

const AUDIO_SOURCES = [Track.Source.Microphone, Track.Source.ScreenShareAudio];

export const CallAudio = () => {
    const views = useContext(ParticipantViewsContext);
    const tracks = useTracks(AUDIO_SOURCES, {onlySubscribed: true})
        .filter(trackRef => !trackRef.participant.isLocal && views.has(trackRef.participant.identity));
    return (
        <div style={{display: 'none'}} data-testid="group-call-audio">
            {tracks.map(trackRef => (
                <AudioTrack
                    key={`${trackRef.participant.identity}|${trackRef.source}|${trackRef.publication.trackSid}`}
                    trackRef={trackRef}
                />
            ))}
        </div>
    );
};
